/* tslint:disable */
/* eslint-disable */
/**
 * Zamna Ready To Fly API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.18
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaxCheckMultipaxSession } from './PaxCheckMultipaxSession';
import {
    PaxCheckMultipaxSessionFromJSON,
    PaxCheckMultipaxSessionFromJSONTyped,
    PaxCheckMultipaxSessionToJSON,
    PaxCheckMultipaxSessionToJSONTyped,
} from './PaxCheckMultipaxSession';
import type { PaxCheckErrorContainer } from './PaxCheckErrorContainer';
import {
    PaxCheckErrorContainerFromJSON,
    PaxCheckErrorContainerFromJSONTyped,
    PaxCheckErrorContainerToJSON,
    PaxCheckErrorContainerToJSONTyped,
} from './PaxCheckErrorContainer';

/**
 * 
 * @export
 * @interface PaxCheckGetSessionResponse
 */
export interface PaxCheckGetSessionResponse {
    /**
     * 
     * @type {PaxCheckMultipaxSession}
     * @memberof PaxCheckGetSessionResponse
     */
    data?: PaxCheckMultipaxSession;
    /**
     * 
     * @type {PaxCheckErrorContainer}
     * @memberof PaxCheckGetSessionResponse
     */
    error?: PaxCheckErrorContainer;
}

/**
 * Check if a given object implements the PaxCheckGetSessionResponse interface.
 */
export function instanceOfPaxCheckGetSessionResponse(value: object): value is PaxCheckGetSessionResponse {
    return true;
}

export function PaxCheckGetSessionResponseFromJSON(json: any): PaxCheckGetSessionResponse {
    return PaxCheckGetSessionResponseFromJSONTyped(json, false);
}

export function PaxCheckGetSessionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaxCheckGetSessionResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : PaxCheckMultipaxSessionFromJSON(json['data']),
        'error': json['error'] == null ? undefined : PaxCheckErrorContainerFromJSON(json['error']),
    };
}

export function PaxCheckGetSessionResponseToJSON(json: any): PaxCheckGetSessionResponse {
    return PaxCheckGetSessionResponseToJSONTyped(json, false);
}

export function PaxCheckGetSessionResponseToJSONTyped(value?: PaxCheckGetSessionResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PaxCheckMultipaxSessionToJSON(value['data']),
        'error': PaxCheckErrorContainerToJSON(value['error']),
    };
}

